// src/components/NoLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";

const NoLayout = () => (
  <div id="main-wrapper">
    <main id="content">
      <Outlet />
    </main>
  </div>
);

export default NoLayout;
